import React, { useState } from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import MetaTags from "react-meta-tags";

export default function PusatBantuanPartner() {
  const [currentProsesPesanan, setCurrentProsesPesanan] = useState(0);
  const [currentSelesaiPesanan, setCurrentSelesaiPesanan] = useState(0);
  const [currentBatalOrder, setCurrentBatalOrder] = useState(0);

  const prosesPesanan = [
    {
      text: "Buka tab 'Pesanan' pada aplikasi UR Partner di tablet/ponsel kasir.",
      image: "../../asset/images/PusatBantuanPartner/order-1.png",
    },
    {
      text: "Pilih nomor meja dan detail item pesanan yang baru masuk.",
      image: "../../asset/images/PusatBantuanPartner/order-3.png",
    },
    {
      text: "Tekan tombol 'Terima Pembayaran' untuk mengonfirmasi transaksi.",
      image: "../../asset/images/PusatBantuanPartner/order-4.png",
    },
    {
      text: "Sistem akan mengirim tiket pesanan ke dapur dan pesanan mulai dimasak.",
      image: "../../asset/images/PusatBantuanPartner/order-5.png",
    },
  ];

  const selesaiPesanan = [
    {
      text: "Buka tab 'Pesanan' dan pilih daftar pesanan yang sedang diproses.",
      image: "../../asset/images/PusatBantuanPartner/order-2.png",
    },
    {
      text: "Pilih pesanan yang hidangannya telah selesai disajikan ke customer.",
      image: "../../asset/images/PusatBantuanPartner/order-3.png",
    },
    {
      text: "Tekan tombol 'Proses Selesai'.",
      image: "../../asset/images/PusatBantuanPartner/order-6.png",
    },
    {
      text: "Status meja otomatis terupdate menjadi selesai dan siap untuk pelanggan berikutnya.",
      image: "../../asset/images/PusatBantuanPartner/order-7.png",
    },
  ];

  const batalOrder = [
    {
      text: "Buka tab 'Pesanan' pada aplikasi kasir.",
      image: "../../asset/images/PusatBantuanPartner/order-2.png",
    },
    {
      text: "Pilih pesanan yang ingin dibatalkan atas permintaan customer.",
      image: "../../asset/images/PusatBantuanPartner/order-3.png",
    },
    {
      text: "Tekan tombol 'Batalkan Pesanan' dan masukkan alasan pembatalan.",
      image: "../../asset/images/PusatBantuanPartner/order-8.png",
    },
    {
      text: "Pesanan berhasil dibatalkan dan rekonsiliasi kasir diperbarui.",
      image: "../../asset/images/PusatBantuanPartner/order-15.png",
    },
  ];

  const sections = [
    {
      title: "Cara Menerima & Memproses Pesanan Masuk",
      items: prosesPesanan,
      current: currentProsesPesanan,
      setter: setCurrentProsesPesanan,
    },
    {
      title: "Cara Menyelesaikan Pesanan Selesai",
      items: selesaiPesanan,
      current: currentSelesaiPesanan,
      setter: setCurrentSelesaiPesanan,
    },
    {
      title: "Cara Membatalkan Pesanan",
      items: batalOrder,
      current: currentBatalOrder,
      setter: setCurrentBatalOrder,
    },
  ];

  return (
    <div style={{ maxWidth: "100%", overflowX: "hidden", backgroundColor: "#ffffff" }}>
      <MetaTags>
        <title>Pusat Bantuan Partner &amp; Merchant | UR</title>
        <meta name="title" content="Pusat Bantuan Partner | UR" />
        <meta
          name="description"
          content="Panduan penggunaan aplikasi kasir UR Partner POS dan manajemen pesanan restoran."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ur-hub.com/pusat-bantuan/partner" />
      </MetaTags>

      {/* Hero */}
      <section
        style={{
          paddingTop: "130px",
          paddingBottom: "64px",
          backgroundColor: "#0f172a",
          color: "#ffffff",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center" justifyContent="space-between">
            <Grid item xs={12} md={7}>
              <div
                style={{
                  color: "#38bdf8",
                  fontSize: "13px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  marginBottom: "12px",
                }}
              >
                Panduan Merchant &amp; Kasir
              </div>

              <Typography
                variant="h1"
                style={{
                  fontWeight: 800,
                  fontSize: "clamp(2rem, 4vw, 3.2rem)",
                  lineHeight: 1.2,
                  letterSpacing: "-0.02em",
                  marginBottom: "14px",
                }}
              >
                Pusat Bantuan UR Partner
              </Typography>

              <Typography
                variant="subtitle1"
                style={{
                  color: "#94a3b8",
                  fontSize: "15px",
                  lineHeight: 1.6,
                  maxWidth: "520px",
                }}
              >
                Panduan praktis bagi staf dan pemilik outlet dalam mengoperasikan sistem kasir POS dan manajemen pesanan UR.
              </Typography>
            </Grid>

            {/* Illustration */}
            <Grid item xs={12} md={5} style={{ textAlign: "center" }}>
              <img
                src="../../asset/images/Illustration/pb_partner.png"
                alt="Partner Help Center"
                style={{
                  maxHeight: "220px",
                  maxWidth: "100%",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Guide Sections */}
      <section style={{ padding: "64px 0 80px 0", backgroundColor: "#f8fafc" }}>
        <Container maxWidth="lg">
          <div style={{ display: "flex", flexDirection: "column", gap: "56px" }}>
            {sections.map((sec, sIdx) => (
              <div
                key={sIdx}
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "16px",
                  padding: "36px 28px",
                  border: "1px solid #e2e8f0",
                }}
              >
                <div style={{ marginBottom: "28px" }}>
                  <Typography
                    variant="h3"
                    style={{
                      fontWeight: 700,
                      color: "#0f172a",
                      fontSize: "20px",
                      marginBottom: "6px",
                    }}
                  >
                    {sec.title}
                  </Typography>
                  <p style={{ color: "#64748b", fontSize: "14px", margin: 0 }}>
                    Pilih langkah di samping atau di bawah untuk melihat screenshot panduan.
                  </p>
                </div>

                <Grid container spacing={4} alignItems="center">
                  {/* Left: Device Screenshot */}
                  <Grid item xs={12} md={6} lg={5} style={{ textAlign: "center" }}>
                    <img
                      src={sec.items[sec.current].image}
                      alt={`Step ${sec.current + 1}`}
                      style={{
                        width: "100%",
                        maxHeight: "350px",
                        height: "auto",
                        objectFit: "contain",
                        borderRadius: "10px",
                        display: "block",
                        margin: "0 auto",
                      }}
                    />
                  </Grid>

                  {/* Right: Step List */}
                  <Grid item xs={12} md={6} lg={7}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                      {sec.items.map((item, idx) => {
                        const isActive = sec.current === idx;
                        return (
                          <div
                            key={idx}
                            onClick={() => sec.setter(idx)}
                            style={{
                              padding: "14px 18px",
                              borderRadius: "10px",
                              backgroundColor: isActive
                                ? "rgba(2, 132, 199, 0.06)"
                                : "#ffffff",
                              border: isActive
                                ? "1.5px solid #0284c7"
                                : "1px solid #e2e8f0",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "14px",
                              transition: "all 0.15s ease",
                            }}
                          >
                            <div
                              style={{
                                width: "26px",
                                height: "26px",
                                borderRadius: "50%",
                                backgroundColor: isActive ? "#0284c7" : "#f1f5f9",
                                color: isActive ? "#ffffff" : "#64748b",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 700,
                                fontSize: "12px",
                                flexShrink: 0,
                              }}
                            >
                              {idx + 1}
                            </div>
                            <span
                              style={{
                                color: isActive ? "#0f172a" : "#64748b",
                                fontWeight: isActive ? 600 : 500,
                                fontSize: "13px",
                                lineHeight: 1.5,
                              }}
                            >
                              {item.text}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </Grid>
                </Grid>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}